module.exports = __webpack_public_path__ + "img/logo-260323.07c6be3d.png";